import React from "react";
import Select from "@dtci/spellbook/Select";
import { Pagination } from "../Pagination";
import { DEFAULT_PAGE_SIZE_OPTIONS } from "tap/utils/paginationPreferences.js";
import "./styles.scss";

const toSelectOptions = (options) =>
  options.map((o) =>
    typeof o === "number" ? { label: String(o), value: o } : o,
  );

/**
 * Shared pagination bar with page navigation, page size selector, and record count.
 *
 * @param {Object} props
 * @param {number} props.totalPages - Total number of pages
 * @param {number} props.currentPage - Current zero-based page index
 * @param {number} props.totalItems - Total record count
 * @param {number} props.itemsPerPage - Current items per page
 * @param {Function} props.onPageChange - Called with page number when page changes
 * @param {Function} props.onPageSizeChange - Called with new page size when dropdown changes
 * @param {Array} [props.pageSizeOptions] - Custom page size options (default: [5, 10, 25, 50, 100])
 */
export function PaginationBar({
  totalPages,
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
}) {
  const rangeStart = currentPage * itemsPerPage + 1;
  const rangeEnd = Math.min(rangeStart + itemsPerPage - 1, totalItems);
  const selectOptions = toSelectOptions(pageSizeOptions);

  return (
    <div className="pagination-bar">
      <div className="pagination-bar-left" />
      <div className="pagination-bar-center">
        <Pagination
          pageCount={totalPages}
          onPageChange={(e) => onPageChange(e.selected)}
          previousLabel="←"
          nextLabel="→"
          forcePage={currentPage}
        />
      </div>
      <div className="pagination-bar-right">
        <div className="pagination-bar-page-size">
          <span>Show</span>
          <Select
            className="pagination-bar-page-size-select"
            options={selectOptions}
            value={selectOptions.find((o) => o.value === itemsPerPage)}
            onChange={(opt) => onPageSizeChange(opt.value)}
            isSearchable={false}
            menuPlacement="auto"
            menuPortalTarget={document.body}
          />
          <span>per page</span>
        </div>
        <span>
          {totalItems > 0
            ? `${rangeStart}-${rangeEnd} of ${totalItems} records`
            : "No records"}
        </span>
      </div>
    </div>
  );
}
